import styled from 'styled-components';
import HygenicRoomSvg from '../../../assets/onboardingNew/homepage/hygienic-rooms.svg';

const HygenicRoomNewIcon = styled(HygenicRoomSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.1rem'};
height: ${props => props.height || '3.8rem'};
display: flex;
`;

export default HygenicRoomNewIcon;
